'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reduxSimple = require('redux-simple');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _CSSCore = require('fbjs/lib/CSSCore');

var _CSSCore2 = _interopRequireDefault(_CSSCore);

var _firebase = require('utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _Popups = require('components/Popups');

var _EditorLinkPreview = require('./EditorLinkPreview');

var _EditorLinkPreview2 = _interopRequireDefault(_EditorLinkPreview);

require('components/Nodes/firepad.less');

var _Common = require('components/Common');

var _Icons = require('components/Common/Icons');

var _editorHelpers = require('./editorHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./Editor.pcss');

var getState = function getState(state) {
  return {
    node: state.nodes.editorNode
  };
};

var getOffsetFromElementWithClassName = function getOffsetFromElementWithClassName(element, className) {
  var node = element;
  var offset = {
    left: 0,
    top: 0
  };
  while (!_CSSCore2.default.hasClass(node, className) && node.nodeName !== 'BODY') {
    offset.top += node.offsetTop;
    offset.left += node.offsetLeft;
    node = node.offsetParent;
  }
  return offset;
};

var NodePage = (_dec = (0, _reduxSimple.connect)(getState), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(NodePage, _Component);

  function NodePage() {
    _classCallCheck(this, NodePage);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NodePage).call(this));

    _this.state = {
      ready: false,
      linkPreview: false,
      linkEditorActive: false,
      linkEditor: {
        text: '',
        url: 'http://'
      }
    };
    _this.linkOffset = null;
    _this.deleteLink = null;
    _this.afterEditLink = null;
    return _this;
  }

  _createClass(NodePage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.init(this.props);
    }
  }, {
    key: 'clearLinkPreview',
    value: function clearLinkPreview() {
      this.setState({
        linkPreview: false
      });
      this.linkOffset = null;
      this.deleteLink = null;
      this.afterEditLink = null;
    }
  }, {
    key: 'linkPreview',
    value: function linkPreview(e, info, methods) {
      var _this2 = this;

      e.preventDefault();

      this.linkOffset = getOffsetFromElementWithClassName(e.target, styles.wrapper);
      this.linkOffset = _extends({}, this.linkOffset, {
        top: this.linkOffset.top + 32
      });

      this.deleteLink = function () {
        methods.remove();
      };
      this.editLink = function () {
        _this2.setState({
          linkPreview: false
        });
        _this2.showLinkPopup(info);
      };
      this.afterEditLink = function (newInfo) {
        methods.replace(newInfo);
      };

      this.setState({
        linkPreview: info
      });
    }
  }, {
    key: 'makeLinkFromFirebase',
    value: function makeLinkFromFirebase(info, methods) {
      var _this3 = this;

      var link = document.createElement('a');
      link.setAttribute('href', info.href);
      link.innerHTML = info.content;
      link.addEventListener('click', function (e) {
        return _this3.linkPreview(e, info, methods);
      });
      if (info.hasOwnProperty('target')) link.setAttribute('target', info.target);
      return link;
    }
  }, {
    key: 'init',
    value: function init(props) {
      var _this4 = this;

      if (!props.node) return;
      var _props$node = this.props.node;
      var refLink = _props$node.refLink;
      var caption = _props$node.caption;

      var nodeCaption = caption + '\n\n\n\n\n\n\n\n';

      var firepadRefPath = refLink + '/firepad';
      this.firepadRef = (0, _firebase2.default)(firepadRefPath);
      this.firePadElement = (0, _reactDom.findDOMNode)(this).getElementsByClassName(styles.firepad)[0];
      this.codeMirror = window.CodeMirror( // eslint-disable-line
      this.firePadElement, { lineWrapping: true });
      this.firepad = window.Firepad.fromCodeMirror(this.firepadRef, this.codeMirror, {
        richTextShortcuts: true,
        richTextToolbar: false,
        defaultText: nodeCaption
      });

      this.firepad.registerEntity('a', {
        render: this.makeLinkFromFirebase.bind(this),
        export: this.makeLinkFromFirebase.bind(this),
        fromElement: _editorHelpers.makeFirebaseFromLink
      });

      this.codeMirror.getWrapperElement().addEventListener('copy', function (e) {
        return (0, _editorHelpers.copy)(_this4.firepad, e);
      });
      this.codeMirror.getWrapperElement().addEventListener('cut', function (e) {
        return (0, _editorHelpers.cut)(_this4.firepad, _this4.codeMirror, e);
      });
      this.codeMirror.getWrapperElement().addEventListener('paste', function (e) {
        return (0, _editorHelpers.paste)(_this4.firepad, e);
      });

      this.firepad.on('ready', function () {
        return _this4.setState({ ready: true });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.firepad) this.firepad.dispose();
    }
  }, {
    key: 'handleFirepadClick',
    value: function handleFirepadClick(ev) {
      ev.stopPropagation();
    }
  }, {
    key: 'handleControlsClick',
    value: function handleControlsClick(ev) {
      ev.stopPropagation();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this5 = this;

      if (props.node && props.node.id !== _lodash2.default.get(this.props.node, 'id')) {
        if (this.firepad) this.firepad.dispose();
        this.setState({ ready: false });
        (0, _reactDom.findDOMNode)(this).getElementsByClassName(styles.firepad)[0].innerHTML = '';
        setTimeout(function () {
          return _this5.init(props);
        }, 100);
      }
    }
  }, {
    key: 'showLinkPopup',
    value: function showLinkPopup(link) {
      this.setState({
        linkEditorActive: true,
        linkEditor: {
          text: link.content || this.codeMirror.getSelection(),
          url: link.href || 'http://'
        }
      });
    }
  }, {
    key: 'hideLinkPopup',
    value: function hideLinkPopup() {
      this.clearLinkPreview();
      this.setState({
        linkEditorActive: false,
        linkEditor: {
          text: '',
          url: 'http://'
        }
      });
    }
  }, {
    key: 'insertLink',
    value: function insertLink(info) {
      var data = {
        href: info.link,
        content: info.text,
        target: '_blank'
      };
      if (this.afterEditLink) {
        this.afterEditLink(data);
        this.clearLinkPreview();
      } else {
        this.codeMirror.replaceSelection('');
        if (this.firepad) {
          this.firepad.insertEntity('a', data);
        }
      }
      this.hideLinkPopup();
    }
  }, {
    key: 'renderButton',
    value: function renderButton(icon, action) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var _this6 = this;

      return _react2.default.createElement(
        _Common.ActionIcon,
        { smallShadow: true, marginedBottom: true, onClick: function onClick() {
            var _firepad;

            return _this6.firepad && (_firepad = _this6.firepad)[action].apply(_firepad, args);
          } },
        icon
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: styles.editor },
        !this.state.ready && this.props.spinner,
        _react2.default.createElement(
          'div',
          { className: styles.controls },
          this.renderButton(_react2.default.createElement(_Icons.EditorBold, { onClick: this.handleControlsClick.bind(this), width: '18', height: '14' }), 'bold'),
          this.renderButton(_react2.default.createElement(_Icons.EditorList, { onClick: this.handleControlsClick.bind(this), width: '16', height: '12' }), 'unorderedList'),
          this.renderButton(_react2.default.createElement(_Icons.EditorNumberedList, { onClick: this.handleControlsClick.bind(this), width: '16', height: '14' }), 'orderedList'),
          _react2.default.createElement(
            _Common.ActionIcon,
            { smallShadow: true, marginedBottom: true, onClick: this.showLinkPopup.bind(this) },
            _react2.default.createElement(_Icons.EditorLink, { width: '14', height: '10' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.wrapper },
          _react2.default.createElement('div', {
            onClick: this.handleFirepadClick.bind(this),
            className: (0, _classnames2.default)(styles.firepad, !this.state.ready && styles.firepadLoading)
          }),
          this.state.linkPreview && _react2.default.createElement(_EditorLinkPreview2.default, {
            clearPreview: this.clearLinkPreview.bind(this),
            offset: this.linkOffset,
            deleteLink: this.deleteLink.bind(this),
            edit: this.editLink.bind(this),
            info: this.state.linkPreview
          })
        ),
        _react2.default.createElement(
          _Popups.PopupAnimator,
          null,
          this.state.linkEditorActive && _react2.default.createElement(
            _Popups.Popup,
            { autoSize: true },
            _react2.default.createElement(
              _Popups.PopupContent,
              null,
              _react2.default.createElement(_Popups.PopupEditorLink, {
                defaultText: this.state.linkEditor.text,
                defaultUrl: this.state.linkEditor.url,
                submit: this.insertLink.bind(this),
                cancel: this.hideLinkPopup.bind(this)
              })
            )
          )
        )
      );
    }
  }]);

  return NodePage;
}(_react.Component), _class2.propTypes = {
  node: _react.PropTypes.object,
  spinner: _react.PropTypes.any.isRequired
}, _temp)) || _class);
exports.default = NodePage;


//////////////////
// WEBPACK FOOTER
// ./app/components/Nodes/Editor.js
// module id = 562
// module chunks = 1